import React, { FC, PropsWithChildren } from 'react'
import { cn } from '../../utils/cn'

interface CardContentProps {
  className?: string
}

export const CardContent: FC<PropsWithChildren<CardContentProps>> = ({
  className,
  children
}) => <div className={cn('p-4', className)}>{children}</div>
